import API from "api/API"
import {Module} from "const/Module"
import {rootClientStore} from "store/client/client.store"

interface ClientInvoiceSettingsPatchData {
  format: string,
  resetMonthly: boolean,
  resetYearly: boolean,
  startNumber: number,
  numberOfZeroes: number
}

function ApiInvoiceNumberSettingsService() {

  async function patchSettings() {
    const editData = rootClientStore.getValue().edit
    if (undefined === editData)
      return

    if (!editData.invoiceNumberSetting)
      return

    await API.patch<void, ClientInvoiceSettingsPatchData>(`${Module.client}/${Module.invoiceNumberSettings}`, editData.invoiceNumberSetting)
  }

  async function lockSettings(locked: boolean) {
    await API.patch(`/${Module.client}/${Module.invoiceNumberSettings}/lock`, {locked})
  }

  return {
    patchSettings,
    lockSettings,
  }
}

export default ApiInvoiceNumberSettingsService
